import React from 'react';
import LandingPage from '../components/LandingPage';

export default function CalgaryFoodScene() {
  return (
    <LandingPage
      testid="calgary-food-scene-page"
      slug="calgary-food-scene"
      title="The Calgary Food Scene: Where to Eat Right Now"
      metaTitle="Calgary Food Scene 2026 — Best Restaurants & Where to Eat | Culinera"
      metaDescription="A local's guide to the Calgary food scene: the best restaurants in Calgary, 17th Avenue chef kitchens, Inglewood gems, and natural-wine bars. Build a free Calgary food itinerary with Culinera."
      heroImage="calgary-food-scene.jpg"
      heroAlt="Warmly lit Calgary chef-driven restaurant interior on 17th Avenue at golden hour, shared plates and natural wine on a wooden counter"
      kicker="Calgary Food Guide"
      wizardCity="Calgary"
      wizardCuisines={['Fine Dining', 'Farm-to-Table']}
      picksHeading="Where to eat in Calgary right now"
      restaurantIds={[
        'model-milk', 'river-cafe', 'pigeonhole', 'shokunin', 'bernadettes',
        'una-pizza', 'ten-foot-henry', 'anju', 'deane-house', 'native-tongues',
        'major-tom', 'calcutta-cricket',
      ]}
      ctaHeading="Plan your Calgary food trip"
      ctaText="Turn these Calgary restaurants into a day-by-day food itinerary — pick your neighbourhoods, your budget, and how many days you have."
      intro={[
        "The **Calgary food scene** has quietly become one of the most exciting in Canada. Over the last decade the city traded its steakhouse-only reputation for something far more interesting: chef-owned rooms, natural-wine cellars, Indigenous-led fine dining, and some of the country's best Japanese and Korean cooking. If you're searching for the **best restaurants in Calgary**, the good news is that most of them sit within a short walk or a ten-minute drive of one another.",
        "The beating heart of it all is **17th Avenue Southwest**, where Model Milk, Pigeonhole and Shokunin anchor a stretch of pavement packed with more chef-driven kitchens than the rest of the city combined. A few blocks away, the Beltline and Stephen Avenue carry the downtown energy — supper-club steakhouses, taquerias, and modern Indian small plates.",
        "Cross the river into **Inglewood** and the mood shifts to neighbourhood-cool: Bernadette's revival Cree kitchen, the heritage Deane House on the river, and Sidewalk Citizen's wood-fired sourdough. For a riverside table, River Café on Prince's Island is the city's farm-to-table flagship and a Calgary institution.",
        "Below are our current picks — real, operating Calgary restaurants worth planning a day around. Tap any of them for hours, the neighbourhood, and what to order, then turn the whole list into a personalized food itinerary.",
      ]}
      faqs={[
        {
          q: 'What is the best neighbourhood for food in Calgary?',
          a: '17th Avenue SW (the Beltline) is the densest stretch of chef-driven restaurants and wine bars in the city. Inglewood and Stephen Avenue are the two other essential food neighbourhoods worth building a trip around.',
        },
        {
          q: 'Where do locals eat in Calgary?',
          a: 'Locals gravitate to spots like Model Milk and Pigeonhole on 17th Ave, Shokunin for yakitori, Bernadette\'s in Inglewood for Indigenous cuisine, and UNA Pizza + Wine for a no-reservations slice and a glass of natural wine.',
        },
        {
          q: 'How many days do you need to eat well in Calgary?',
          a: 'Two days covers the essentials — one for 17th Avenue and the Beltline, one for Inglewood and the river. Use the Culinera itinerary planner to space your reservations across the days you have.',
        },
      ]}
    />
  );
}
